import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import type { EntityDetail } from '@web-config-app/core';
import {
  StackLayout,
  UtilityText,
  VisuallyHidden,
} from '@leagueplatform/genesis-core';
import { CopyButton } from '../../copy-button/copy-button.component';
import { TableCell } from '../table-pieces.component';

export type UrlCellProps = {
  item: EntityDetail;
  value: unknown;
};

export const UrlCell: React.FC<UrlCellProps> = ({ item, value }) => {
  const { formatMessage } = useIntl();

  return (
    <TableCell data-entity-id={item.id}>
      <StackLayout
        orientation="horizontal"
        verticalAlignment="center"
        spacing="$half"
        horizontalAlignment="spaceBetween"
      >
        <UtilityText
          data-testid={formatMessage({ id: 'COPY_URL' })}
          emphasis="subtle"
          size="sm"
          title={String(value ?? '')}
          css={{
            // set the direction to rtl
            // since urls are always from left to right, regardless of language direction, this will allow us to truncate the start of the url and show the end of the url
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            direction: 'rtl',
            textAlign: 'left',
          }}
          // adding aria-hidden to the utility text so that the rtl styles don't impact the screen reader experience, and instead render a visually hidden element with the same value
          aria-hidden
        >
          {String(value ?? '')}
        </UtilityText>
        <VisuallyHidden>{String(value ?? '')}</VisuallyHidden>
        <CopyButton
          label={formatMessage({ id: 'COPY_URL' })}
          priority="tertiary"
          contents={String(value ?? '')}
          hideLabel
        />
      </StackLayout>
    </TableCell>
  );
};
